/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm} from '@insticator/insticator-ui';

/* ++++++++++ --------------- app.filters : STYLES --------------- ++++++++++ */
export default {
    space: {
      width: '100%',
      display: 'flex',
      flexWrap: ({ flexWrap }) => flexWrap ? 'wrap' : 'nowrap',
      flexDirection: ({ direction }) => direction || 'row',
      rowGap: ({ gap, hGap }) => `${gap ?? hGap ?? 8}px`,
      columnGap: ({ gap, vGap }) => `${gap ?? vGap ?? 8}px`,
      flex: ({ flex }) => flex || 'initial',
      justifyContent: ({ justifyContent }) => justifyContent || 'initial',
      alignItems: ({ alignItems }) => alignItems || 'initial'
    }
};
